var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { classNames } from "../util/common-utilities";
export default function RelianceTerms() {
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: classNames("w-full justify-center pt-4 pb-8 clearfix") }, { children: _jsx("p", __assign({ className: "w-11/12 mx-auto color-QUIZ_NOTICE_TEXT" }, { children: "By submitting this form, you are agreeing to allow Reliance Litigation LLC to contact you at the phone number you supplied, even if it's on a national or state Do-Not-Call List. Calls/texts may employ automated dialing technology and prerecorded/artificial voice messages and emails. You are also confirming that you understand that your consent is not a condition of any purchase or obligation, and that this submission does not form an attorney/client relationship." }), void 0) }), void 0) }, void 0));
}
